import {Component, Input} from '@angular/core';
import {RouterLink} from '@angular/router';
import {DoodleComponent} from '../../shared/doodle/doodle.component';

interface StoryPrompt {
  genre: string;
  text: string;
}

/**
 * The closing card on the landing page: one story idea at a time, shuffled on request,
 * to show that a single line is enough to start a book.
 */
@Component({
  selector: 'app-story-prompt',
  templateUrl: './story-prompt.component.html',
  styleUrls: ['./story-prompt.component.scss'],
  imports: [RouterLink, DoodleComponent]
})
export class StoryPromptComponent {

  @Input() userIsLoggedIn = false;

  readonly prompts: StoryPrompt[] = [
    {genre: 'Ghost story', text: 'A lighthouse keeper starts receiving letters from a ship that sank a hundred years ago.'},
    {genre: 'Fantasy', text: 'Magic is a finite resource, and the city has just spent the last of it.'},
    {genre: 'Mystery', text: 'The quietest person on the night train is the only one who saw what happened in carriage four.'},
    {genre: 'Adventure', text: 'A mapmaker is hired to chart a forest that rearranges itself every night.'},
    {genre: 'Romance', text: 'Two rival bakers in a mountain village have been writing each other anonymous letters for a year.'},
    {genre: 'Comic fantasy', text: 'The dragon would like to retire, and is interviewing for someone to take over the hoard.'},
    {genre: 'Science fiction', text: 'The translator realises the visiting delegation has been lying to Earth, beautifully, for years.'},
    {genre: 'Magical realism', text: 'In this town, every lie you tell comes true by morning.'},
    {genre: 'Fairy tale', text: 'What happened after "happily ever after", told by the castle cook.'}
  ];

  index = 0;
  /** Bumped on every shuffle so the card re-runs its entrance animation. */
  turn = 0;

  get prompt(): StoryPrompt {
    return this.prompts[this.index];
  }

  next() {
    this.index = (this.index + 1) % this.prompts.length;
    this.turn++;
  }
}
